import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.3329 0C6.22733 0.000815494 5.33257 0.896228 5.33339 1.99959C5.33257 3.10296 6.22814 3.99837 7.33372 3.99918H9.33404V2.00041C9.33486 0.897044 8.43929 0.00163099 7.3329 0C7.33372 0 7.33372 0 7.3329 0ZM7.3329 5.33333H2.00033C0.894756 5.33415 -0.000814894 6.22956 2.23311e-06 7.33293C-0.00163202 8.43629 0.893939 9.3317 1.99951 9.33333H7.3329C8.43847 9.33252 9.33404 8.4371 9.33323 7.33374C9.33404 6.22956 8.43847 5.33415 7.3329 5.33333Z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 7.33293C20.0008 6.22956 19.1052 5.33415 17.9996 5.33333C16.8941 5.33415 15.9985 6.22956 15.9993 7.33293V9.33333H17.9996C19.1052 9.33252 20.0008 8.4371 20 7.33293ZM14.6666 7.33293V1.99959C14.6674 0.897044 13.7726 0.00163099 12.6671 0C11.5615 0.000815494 10.6659 0.896228 10.6668 1.99959V7.33293C10.6651 8.43629 11.5607 9.3317 12.6663 9.33333C13.7718 9.33252 14.6674 8.4371 14.6666 7.33293Z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6663 20C13.7719 19.9992 14.6674 19.1038 14.6666 18.0004C14.6674 16.8971 13.7719 16.0016 12.6663 16.0008H10.666V18.0004C10.6651 19.103 11.5607 19.9984 12.6663 20ZM12.6663 14.6659H17.9997C19.1052 14.665 20.0008 13.7696 20 12.6663C20.0016 11.5629 19.1061 10.6675 18.0005 10.6659H12.6671C11.5615 10.6667 10.666 11.5621 10.6668 12.6655C10.666 13.7696 11.5607 14.665 12.6663 14.6659Z",
			fill: "#ECB22E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.58721e-07 12.6662C-0.000816568 13.7696 0.894754 14.665 2.00033 14.6658C3.1059 14.665 4.00147 13.7696 4.00065 12.6662V10.6667H2.00033C0.894754 10.6675 -0.000816568 11.5629 5.58721e-07 12.6662ZM5.33339 12.6662V17.9996C5.33175 19.1029 6.22732 19.9984 7.3329 20C8.43847 19.9992 9.33404 19.1038 9.33322 18.0004V12.6679C9.33486 11.5645 8.43929 10.6691 7.33371 10.6675C6.22732 10.6675 5.33257 11.5629 5.33339 12.6662Z",
			fill: "#E01E5A"
		})
	]
});
export default SvgSlack;
